import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import Quill from 'quill';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuillIconInitializerService {
  private readonly http = inject(HttpClient);

  async initialize(): Promise<void> {
    const icons = Quill.import('ui/icons');

    const [
      boldIconSvg,
      italicIconSvg,
      cleanIconSvg,
      underlineIconSvg,
      strikeIconSvg,
      blockquoteIconSvg,
      listOrderedIconSvg,
      listBulletIconSvg,
      indentDecreaseIconSvg,
      indentIncreaseIconSvg,
      colorIconSvg,
      backgroundIconSvg,
      linkIconSvg,
      alignLeftIconSvg,
      alignRightIconSvg,
      alignCenterIconSvg,
      alignJustifyIconSvg,
    ] = await Promise.all([
      lastValueFrom(this.http.get('assets/icons/material/format_bold.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_italic.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_clear.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_underlined.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_strikethrough.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_quote.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_list_numbered.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_list_bulleted.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_indent_decrease.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_indent_increase.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_color_text.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_color_fill.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/link.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_align_left.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_align_right.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_align_center.svg', { responseType: 'text' })),
      lastValueFrom(this.http.get('assets/icons/material/format_align_justify.svg', { responseType: 'text' })),
    ]);

    icons['bold'] = boldIconSvg;
    icons['italic'] = italicIconSvg;
    icons['underline'] = underlineIconSvg;
    icons['strike'] = strikeIconSvg;
    icons['blockquote'] = blockquoteIconSvg;
    icons['list'] = {
      ordered: listOrderedIconSvg,
      bullet: listBulletIconSvg,
    };

    icons['indent'] = {
      '-1': indentDecreaseIconSvg,
      '+1': indentIncreaseIconSvg,
    };
    icons['color'] = colorIconSvg;
    icons['background'] = backgroundIconSvg;
    icons['link'] = linkIconSvg;

    icons['clean'] = cleanIconSvg;
    icons['align'] = {
      '': alignLeftIconSvg,
      center: alignCenterIconSvg,
      right: alignRightIconSvg,
      justify: alignJustifyIconSvg,
    };
  }
}
